// http://m.mlb.com/glossary/statcast/batted-ball-event

import PitchResult from "../enums/PitchResult.js";

// A Batted Ball Event represents any batted ball that produces a result. This includes outs, hits and errors.
// Any fair ball is a Batted Ball Event. So, too, are foul balls that result in an out or an error.
const battedBallEvents = [
    PitchResult.Single.key, PitchResult.Double.key,
    PitchResult.Triple.key, PitchResult.HomeRun.key,
    PitchResult.ContactOut.key, PitchResult.Error.key,
];

// this is actually equal to fair ball definition
const battedBallEventClassifier = function(taggedPitchResultKey) {
    if (typeof taggedPitchResultKey !== 'string'){
        return false;
    }

    return battedBallEvents.includes(taggedPitchResultKey);
}

export default battedBallEventClassifier;